// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file organization_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ContractStatus, ContractStatusJson, JobCategory, JobCategoryJson, TruckType, TruckTypeJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { EmptyMessageRequestSchema, EmptyMessageResponseSchema, ListFilter, ListFilterJson, ListInfo, ListInfoJson, MessageResponseSchema, OrganizationLabelCreateSchema, OrganizationLabelListRequestSchema, OrganizationLabelListSchema, OrganizationLabelSchema, OrganizationLabelUpdateSchema } from "./general_pb";
import { file_general } from "./general_pb";
import type { AccessibleOrganizationListRequestSchema, Organization, OrganizationCreate, OrganizationCreateJson, OrganizationCreateSchema, OrganizationJson, OrganizationListSchema, OrganizationSchema, OrganizationSubtreeRequestSchema, OrganizationUpdateSchema } from "./organization_pb";
import { file_organization } from "./organization_pb";
import type { DisabledJobTypesSchema, OrganizationSettingsSchema, OrganizationSettingsUpdateSchema } from "./organization_settings_pb";
import { file_organization_settings } from "./organization_settings_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file organization_service.proto.
 */
export const file_organization_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_enums, file_general, file_organization, file_organization_settings]);

/**
 * @generated from message raccoonai.AddGuestRequest
 */
export type AddGuestRequest = Message<"raccoonai.AddGuestRequest"> & {
  /**
   * @generated from field: required string org_name = 1 [json_name = "org_name"];
   */
  orgName: string;

  /**
   * @generated from field: required string bin = 2;
   */
  bin: string;

  /**
   * @generated from field: required string driver_first_name = 3 [json_name = "driver_first_name"];
   */
  driverFirstName: string;

  /**
   * @generated from field: required string driver_last_name = 4 [json_name = "driver_last_name"];
   */
  driverLastName: string;

  /**
   * @generated from field: required string driver_phone_number = 5 [json_name = "driver_phone_number"];
   */
  driverPhoneNumber: string;

  /**
   * @generated from field: optional string driver_license_number = 6 [json_name = "driver_license_number"];
   */
  driverLicenseNumber: string;

  /**
   * @generated from field: required string truck_plate_number = 7 [json_name = "truck_plate_number"];
   */
  truckPlateNumber: string;

  /**
   * @generated from field: required raccoonai.TruckType truck_type = 8 [json_name = "truck_type"];
   */
  truckType: TruckType;
};

/**
 * @generated from message raccoonai.AddGuestRequest
 */
export type AddGuestRequestJson = {
  /**
   * @generated from field: required string org_name = 1 [json_name = "org_name"];
   */
  org_name?: string;

  /**
   * @generated from field: required string bin = 2;
   */
  bin?: string;

  /**
   * @generated from field: required string driver_first_name = 3 [json_name = "driver_first_name"];
   */
  driver_first_name?: string;

  /**
   * @generated from field: required string driver_last_name = 4 [json_name = "driver_last_name"];
   */
  driver_last_name?: string;

  /**
   * @generated from field: required string driver_phone_number = 5 [json_name = "driver_phone_number"];
   */
  driver_phone_number?: string;

  /**
   * @generated from field: optional string driver_license_number = 6 [json_name = "driver_license_number"];
   */
  driver_license_number?: string;

  /**
   * @generated from field: required string truck_plate_number = 7 [json_name = "truck_plate_number"];
   */
  truck_plate_number?: string;

  /**
   * @generated from field: required raccoonai.TruckType truck_type = 8 [json_name = "truck_type"];
   */
  truck_type?: TruckTypeJson;
};

/**
 * Describes the message raccoonai.AddGuestRequest.
 * Use `create(AddGuestRequestSchema)` to create a new message.
 */
export const AddGuestRequestSchema: GenMessage<AddGuestRequest, {jsonType: AddGuestRequestJson}> = /*@__PURE__*/
  messageDesc(file_organization_service, 0);

/**
 * @generated from message raccoonai.AddGuestResponse
 */
export type AddGuestResponse = Message<"raccoonai.AddGuestResponse"> & {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organizationId: bigint;

  /**
   * @generated from field: required uint64 driver_id = 2 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: required uint64 truck_id = 3 [json_name = "truck_id"];
   */
  truckId: bigint;
};

/**
 * @generated from message raccoonai.AddGuestResponse
 */
export type AddGuestResponseJson = {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organization_id?: string;

  /**
   * @generated from field: required uint64 driver_id = 2 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: required uint64 truck_id = 3 [json_name = "truck_id"];
   */
  truck_id?: string;
};

/**
 * Describes the message raccoonai.AddGuestResponse.
 * Use `create(AddGuestResponseSchema)` to create a new message.
 */
export const AddGuestResponseSchema: GenMessage<AddGuestResponse, {jsonType: AddGuestResponseJson}> = /*@__PURE__*/
  messageDesc(file_organization_service, 1);

/**
 * @generated from message raccoonai.CreateGuestOrganizationRequest
 */
export type CreateGuestOrganizationRequest = Message<"raccoonai.CreateGuestOrganizationRequest"> & {
  /**
   * @generated from field: required string org_name = 1 [json_name = "org_name"];
   */
  orgName: string;

  /**
   * @generated from field: required string bin = 2;
   */
  bin: string;
};

/**
 * @generated from message raccoonai.CreateGuestOrganizationRequest
 */
export type CreateGuestOrganizationRequestJson = {
  /**
   * @generated from field: required string org_name = 1 [json_name = "org_name"];
   */
  org_name?: string;

  /**
   * @generated from field: required string bin = 2;
   */
  bin?: string;
};

/**
 * Describes the message raccoonai.CreateGuestOrganizationRequest.
 * Use `create(CreateGuestOrganizationRequestSchema)` to create a new message.
 */
export const CreateGuestOrganizationRequestSchema: GenMessage<CreateGuestOrganizationRequest, {jsonType: CreateGuestOrganizationRequestJson}> = /*@__PURE__*/
  messageDesc(file_organization_service, 2);

/**
 * @generated from message raccoonai.CreateGuestOrganizationResponse
 */
export type CreateGuestOrganizationResponse = Message<"raccoonai.CreateGuestOrganizationResponse"> & {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organizationId: bigint;
};

/**
 * @generated from message raccoonai.CreateGuestOrganizationResponse
 */
export type CreateGuestOrganizationResponseJson = {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organization_id?: string;
};

/**
 * Describes the message raccoonai.CreateGuestOrganizationResponse.
 * Use `create(CreateGuestOrganizationResponseSchema)` to create a new message.
 */
export const CreateGuestOrganizationResponseSchema: GenMessage<CreateGuestOrganizationResponse, {jsonType: CreateGuestOrganizationResponseJson}> = /*@__PURE__*/
  messageDesc(file_organization_service, 3);

/**
 * @generated from message raccoonai.OrganizationRequest
 */
export type OrganizationRequest = Message<"raccoonai.OrganizationRequest"> & {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organizationId: bigint;
};

/**
 * @generated from message raccoonai.OrganizationRequest
 */
export type OrganizationRequestJson = {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organization_id?: string;
};

/**
 * Describes the message raccoonai.OrganizationRequest.
 * Use `create(OrganizationRequestSchema)` to create a new message.
 */
export const OrganizationRequestSchema: GenMessage<OrganizationRequest, {jsonType: OrganizationRequestJson}> = /*@__PURE__*/
  messageDesc(file_organization_service, 4);

/**
 * @generated from message raccoonai.ServiceReceiverListRequest
 */
export type ServiceReceiverListRequest = Message<"raccoonai.ServiceReceiverListRequest"> & {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organizationId: bigint;

  /**
   * Only receivers whose contract with this organization prices a job type of
   * one of these categories (the contract's container group schedules are the
   * fallback when it carries no tariff map).
   *
   * @generated from field: repeated raccoonai.JobCategory job_categories = 2 [json_name = "job_categories"];
   */
  jobCategories: JobCategory[];
};

/**
 * @generated from message raccoonai.ServiceReceiverListRequest
 */
export type ServiceReceiverListRequestJson = {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organization_id?: string;

  /**
   * Only receivers whose contract with this organization prices a job type of
   * one of these categories (the contract's container group schedules are the
   * fallback when it carries no tariff map).
   *
   * @generated from field: repeated raccoonai.JobCategory job_categories = 2 [json_name = "job_categories"];
   */
  job_categories?: JobCategoryJson[];
};

/**
 * Describes the message raccoonai.ServiceReceiverListRequest.
 * Use `create(ServiceReceiverListRequestSchema)` to create a new message.
 */
export const ServiceReceiverListRequestSchema: GenMessage<ServiceReceiverListRequest, {jsonType: ServiceReceiverListRequestJson}> = /*@__PURE__*/
  messageDesc(file_organization_service, 5);

/**
 * @generated from message raccoonai.ChildrenOrganizationListRequest
 */
export type ChildrenOrganizationListRequest = Message<"raccoonai.ChildrenOrganizationListRequest"> & {
  /**
   * To be required
   *
   * @generated from field: optional uint64 parent_organization_id = 1 [json_name = "parent_organization_id"];
   */
  parentOrganizationId: bigint;

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;
};

/**
 * @generated from message raccoonai.ChildrenOrganizationListRequest
 */
export type ChildrenOrganizationListRequestJson = {
  /**
   * To be required
   *
   * @generated from field: optional uint64 parent_organization_id = 1 [json_name = "parent_organization_id"];
   */
  parent_organization_id?: string;

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;
};

/**
 * Describes the message raccoonai.ChildrenOrganizationListRequest.
 * Use `create(ChildrenOrganizationListRequestSchema)` to create a new message.
 */
export const ChildrenOrganizationListRequestSchema: GenMessage<ChildrenOrganizationListRequest, {jsonType: ChildrenOrganizationListRequestJson}> = /*@__PURE__*/
  messageDesc(file_organization_service, 6);

/**
 * @generated from message raccoonai.ServiceReceiverCreateRequest
 */
export type ServiceReceiverCreateRequest = Message<"raccoonai.ServiceReceiverCreateRequest"> & {
  /**
   * @generated from field: required raccoonai.OrganizationCreate organization = 1;
   */
  organization?: OrganizationCreate;

  /**
   * @generated from field: required uint64 service_provider_id = 2 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;
};

/**
 * @generated from message raccoonai.ServiceReceiverCreateRequest
 */
export type ServiceReceiverCreateRequestJson = {
  /**
   * @generated from field: required raccoonai.OrganizationCreate organization = 1;
   */
  organization?: OrganizationCreateJson;

  /**
   * @generated from field: required uint64 service_provider_id = 2 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;
};

/**
 * Describes the message raccoonai.ServiceReceiverCreateRequest.
 * Use `create(ServiceReceiverCreateRequestSchema)` to create a new message.
 */
export const ServiceReceiverCreateRequestSchema: GenMessage<ServiceReceiverCreateRequest, {jsonType: ServiceReceiverCreateRequestJson}> = /*@__PURE__*/
  messageDesc(file_organization_service, 7);

/**
 * @generated from message raccoonai.GrantParentAccessToChildOrgRequest
 */
export type GrantParentAccessToChildOrgRequest = Message<"raccoonai.GrantParentAccessToChildOrgRequest"> & {
  /**
   * @generated from field: required uint64 child_org_id = 1 [json_name = "child_org_id"];
   */
  childOrgId: bigint;

  /**
   * @generated from field: required string role = 2;
   */
  role: string;
};

/**
 * @generated from message raccoonai.GrantParentAccessToChildOrgRequest
 */
export type GrantParentAccessToChildOrgRequestJson = {
  /**
   * @generated from field: required uint64 child_org_id = 1 [json_name = "child_org_id"];
   */
  child_org_id?: string;

  /**
   * @generated from field: required string role = 2;
   */
  role?: string;
};

/**
 * Describes the message raccoonai.GrantParentAccessToChildOrgRequest.
 * Use `create(GrantParentAccessToChildOrgRequestSchema)` to create a new message.
 */
export const GrantParentAccessToChildOrgRequestSchema: GenMessage<GrantParentAccessToChildOrgRequest, {jsonType: GrantParentAccessToChildOrgRequestJson}> = /*@__PURE__*/
  messageDesc(file_organization_service, 8);

/**
 * @generated from message raccoonai.ListCounterpartiesRequest
 */
export type ListCounterpartiesRequest = Message<"raccoonai.ListCounterpartiesRequest"> & {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organizationId: bigint;

  /**
   * @generated from field: optional raccoonai.ContractStatus status = 2;
   */
  status: ContractStatus;

  /**
   * @generated from field: optional string search = 3;
   */
  search: string;

  /**
   * @generated from field: repeated uint64 manager_ids = 4 [json_name = "manager_ids"];
   */
  managerIds: bigint[];

  /**
   * 0 matches counterparties with no customer type.
   *
   * @generated from field: repeated uint64 customer_type_ids = 5 [json_name = "customer_type_ids"];
   */
  customerTypeIds: bigint[];

  /**
   * facets: "status" (ContractStatus of each counterparty's strongest contract),
   * "customer_type_id" (FacetCounts.id_counts, 0 = no type).
   *
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;
};

/**
 * @generated from message raccoonai.ListCounterpartiesRequest
 */
export type ListCounterpartiesRequestJson = {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organization_id?: string;

  /**
   * @generated from field: optional raccoonai.ContractStatus status = 2;
   */
  status?: ContractStatusJson;

  /**
   * @generated from field: optional string search = 3;
   */
  search?: string;

  /**
   * @generated from field: repeated uint64 manager_ids = 4 [json_name = "manager_ids"];
   */
  manager_ids?: string[];

  /**
   * 0 matches counterparties with no customer type.
   *
   * @generated from field: repeated uint64 customer_type_ids = 5 [json_name = "customer_type_ids"];
   */
  customer_type_ids?: string[];

  /**
   * facets: "status" (ContractStatus of each counterparty's strongest contract),
   * "customer_type_id" (FacetCounts.id_counts, 0 = no type).
   *
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;
};

/**
 * Describes the message raccoonai.ListCounterpartiesRequest.
 * Use `create(ListCounterpartiesRequestSchema)` to create a new message.
 */
export const ListCounterpartiesRequestSchema: GenMessage<ListCounterpartiesRequest, {jsonType: ListCounterpartiesRequestJson}> = /*@__PURE__*/
  messageDesc(file_organization_service, 9);

/**
 * @generated from message raccoonai.Counterparty
 */
export type Counterparty = Message<"raccoonai.Counterparty"> & {
  /**
   * @generated from field: required raccoonai.Organization organization = 1;
   */
  organization?: Organization;

  /**
   * @generated from field: required raccoonai.ContractStatus contract_status = 2 [json_name = "contract_status"];
   */
  contractStatus: ContractStatus;

  /**
   * The requesting organization's customer type for this counterparty; unset: none.
   * Per provider: one receiver can be a construction customer for one provider
   * and a manufacturing one for another.
   *
   * @generated from field: optional uint64 customer_type_id = 3 [json_name = "customer_type_id"];
   */
  customerTypeId: bigint;
};

/**
 * @generated from message raccoonai.Counterparty
 */
export type CounterpartyJson = {
  /**
   * @generated from field: required raccoonai.Organization organization = 1;
   */
  organization?: OrganizationJson;

  /**
   * @generated from field: required raccoonai.ContractStatus contract_status = 2 [json_name = "contract_status"];
   */
  contract_status?: ContractStatusJson;

  /**
   * The requesting organization's customer type for this counterparty; unset: none.
   * Per provider: one receiver can be a construction customer for one provider
   * and a manufacturing one for another.
   *
   * @generated from field: optional uint64 customer_type_id = 3 [json_name = "customer_type_id"];
   */
  customer_type_id?: string;
};

/**
 * Describes the message raccoonai.Counterparty.
 * Use `create(CounterpartySchema)` to create a new message.
 */
export const CounterpartySchema: GenMessage<Counterparty, {jsonType: CounterpartyJson}> = /*@__PURE__*/
  messageDesc(file_organization_service, 10);

/**
 * @generated from message raccoonai.SetCounterpartyCustomerTypeRequest
 */
export type SetCounterpartyCustomerTypeRequest = Message<"raccoonai.SetCounterpartyCustomerTypeRequest"> & {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organizationId: bigint;

  /**
   * @generated from field: required uint64 counterparty_id = 2 [json_name = "counterparty_id"];
   */
  counterpartyId: bigint;

  /**
   * unset or 0 clears
   *
   * @generated from field: optional uint64 customer_type_id = 3 [json_name = "customer_type_id"];
   */
  customerTypeId: bigint;
};

/**
 * @generated from message raccoonai.SetCounterpartyCustomerTypeRequest
 */
export type SetCounterpartyCustomerTypeRequestJson = {
  /**
   * @generated from field: required uint64 organization_id = 1 [json_name = "organization_id"];
   */
  organization_id?: string;

  /**
   * @generated from field: required uint64 counterparty_id = 2 [json_name = "counterparty_id"];
   */
  counterparty_id?: string;

  /**
   * unset or 0 clears
   *
   * @generated from field: optional uint64 customer_type_id = 3 [json_name = "customer_type_id"];
   */
  customer_type_id?: string;
};

/**
 * Describes the message raccoonai.SetCounterpartyCustomerTypeRequest.
 * Use `create(SetCounterpartyCustomerTypeRequestSchema)` to create a new message.
 */
export const SetCounterpartyCustomerTypeRequestSchema: GenMessage<SetCounterpartyCustomerTypeRequest, {jsonType: SetCounterpartyCustomerTypeRequestJson}> = /*@__PURE__*/
  messageDesc(file_organization_service, 11);

/**
 * @generated from message raccoonai.CounterpartyList
 */
export type CounterpartyList = Message<"raccoonai.CounterpartyList"> & {
  /**
   * @generated from field: repeated raccoonai.Counterparty counterparties = 1;
   */
  counterparties: Counterparty[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.CounterpartyList
 */
export type CounterpartyListJson = {
  /**
   * @generated from field: repeated raccoonai.Counterparty counterparties = 1;
   */
  counterparties?: CounterpartyJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.CounterpartyList.
 * Use `create(CounterpartyListSchema)` to create a new message.
 */
export const CounterpartyListSchema: GenMessage<CounterpartyList, {jsonType: CounterpartyListJson}> = /*@__PURE__*/
  messageDesc(file_organization_service, 12);

/**
 * @generated from service raccoonai.OrganizationService
 */
export const OrganizationService: GenService<{
  /**
   * requests releted to guest orgs and users, which will be used by waste disposals
   * to register in their system one-time clients
   *
   * @generated from rpc raccoonai.OrganizationService.ListGuestOrganizations
   */
  listGuestOrganizations: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof OrganizationListSchema;
  },
  /**
   * @generated from rpc raccoonai.OrganizationService.AddGuest
   */
  addGuest: {
    methodKind: "unary";
    input: typeof AddGuestRequestSchema;
    output: typeof AddGuestResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.OrganizationService.CreateGuestOrganization
   */
  createGuestOrganization: {
    methodKind: "unary";
    input: typeof CreateGuestOrganizationRequestSchema;
    output: typeof CreateGuestOrganizationResponseSchema;
  },
  /**
   * organization settings related requests
   *
   * @generated from rpc raccoonai.OrganizationService.GetSetting
   */
  getSetting: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof OrganizationSettingsSchema;
  },
  /**
   * @generated from rpc raccoonai.OrganizationService.UpdateSetting
   */
  updateSetting: {
    methodKind: "unary";
    input: typeof OrganizationSettingsUpdateSchema;
    output: typeof OrganizationSettingsSchema;
  },
  /**
   * Replaces the caller organization's disabled job types.
   *
   * @generated from rpc raccoonai.OrganizationService.UpdateDisabledJobTypes
   */
  updateDisabledJobTypes: {
    methodKind: "unary";
    input: typeof DisabledJobTypesSchema;
    output: typeof OrganizationSettingsSchema;
  },
  /**
   * can be used by service providers
   *
   * @generated from rpc raccoonai.OrganizationService.ListServiceReceivers
   */
  listServiceReceivers: {
    methodKind: "unary";
    input: typeof ServiceReceiverListRequestSchema;
    output: typeof OrganizationListSchema;
  },
  /**
   * @generated from rpc raccoonai.OrganizationService.CreateServiceReceiver
   */
  createServiceReceiver: {
    methodKind: "unary";
    input: typeof ServiceReceiverCreateRequestSchema;
    output: typeof OrganizationSchema;
  },
  /**
   * can be used by service receivers
   *
   * @generated from rpc raccoonai.OrganizationService.ListServiceProvider
   */
  listServiceProvider: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof OrganizationListSchema;
  },
  /**
   * can be used by parent org owners to create a sub-organization under their org
   *
   * @generated from rpc raccoonai.OrganizationService.CreateChildOrganization
   */
  createChildOrganization: {
    methodKind: "unary";
    input: typeof OrganizationCreateSchema;
    output: typeof OrganizationSchema;
  },
  /**
   * grants parent org users with the given role membership in the matching child org group
   *
   * @generated from rpc raccoonai.OrganizationService.GrantParentAccessToChildOrg
   */
  grantParentAccessToChildOrg: {
    methodKind: "unary";
    input: typeof GrantParentAccessToChildOrgRequestSchema;
    output: typeof EmptyMessageResponseSchema;
  },
  /**
   * general organization requests
   *
   * @generated from rpc raccoonai.OrganizationService.ListDisposalSiteOperators
   */
  listDisposalSiteOperators: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof OrganizationListSchema;
  },
  /**
   * @generated from rpc raccoonai.OrganizationService.ListChildrenOrganization
   */
  listChildrenOrganization: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof OrganizationListSchema;
  },
  /**
   * @generated from rpc raccoonai.OrganizationService.ListAccessibleOrganizations
   */
  listAccessibleOrganizations: {
    methodKind: "unary";
    input: typeof AccessibleOrganizationListRequestSchema;
    output: typeof OrganizationListSchema;
  },
  /**
   * @generated from rpc raccoonai.OrganizationService.ListOrganizationSubtree
   */
  listOrganizationSubtree: {
    methodKind: "unary";
    input: typeof OrganizationSubtreeRequestSchema;
    output: typeof OrganizationListSchema;
  },
  /**
   * @generated from rpc raccoonai.OrganizationService.ListCounterparties
   */
  listCounterparties: {
    methodKind: "unary";
    input: typeof ListCounterpartiesRequestSchema;
    output: typeof CounterpartyListSchema;
  },
  /**
   * @generated from rpc raccoonai.OrganizationService.SetCounterpartyCustomerType
   */
  setCounterpartyCustomerType: {
    methodKind: "unary";
    input: typeof SetCounterpartyCustomerTypeRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * Customer types of a service provider. Archive / restore with Update(status).
   *
   * @generated from rpc raccoonai.OrganizationService.CreateCustomerType
   */
  createCustomerType: {
    methodKind: "unary";
    input: typeof OrganizationLabelCreateSchema;
    output: typeof OrganizationLabelSchema;
  },
  /**
   * @generated from rpc raccoonai.OrganizationService.UpdateCustomerType
   */
  updateCustomerType: {
    methodKind: "unary";
    input: typeof OrganizationLabelUpdateSchema;
    output: typeof OrganizationLabelSchema;
  },
  /**
   * @generated from rpc raccoonai.OrganizationService.ListCustomerTypes
   */
  listCustomerTypes: {
    methodKind: "unary";
    input: typeof OrganizationLabelListRequestSchema;
    output: typeof OrganizationLabelListSchema;
  },
  /**
   * @generated from rpc raccoonai.OrganizationService.GetOrganization
   */
  getOrganization: {
    methodKind: "unary";
    input: typeof OrganizationRequestSchema;
    output: typeof OrganizationSchema;
  },
  /**
   * @generated from rpc raccoonai.OrganizationService.UpdateOrganization
   */
  updateOrganization: {
    methodKind: "unary";
    input: typeof OrganizationUpdateSchema;
    output: typeof OrganizationSchema;
  },
  /**
   * @generated from rpc raccoonai.OrganizationService.MyOrganization
   */
  myOrganization: {
    methodKind: "unary";
    input: typeof EmptyMessageRequestSchema;
    output: typeof OrganizationSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_organization_service, 0);

